import {put, takeLatest, call} from 'redux-saga/effects';
import * as productTypeService from "../../../../services/productTypeService";
import {
    UNDELETE_PRODUCT_TYPE,
    GET_PRODUCT_TYPES_SUCCESS,
    UNDELETE_PRODUCT_TYPE_ERROR,
}
    from "../../../actions/menu/productTypes";

function* unDeleteProductTypeSaga(action) {
    try {
        yield call(productTypeService.UnDeleteProductType, action.payload)
        yield put({
            type: GET_PRODUCT_TYPES_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: UNDELETE_PRODUCT_TYPE_ERROR,error: error.data
        });
    }
}


export function* unDeleteProductTypeSagaWatcher() {
    yield takeLatest(UNDELETE_PRODUCT_TYPE, unDeleteProductTypeSaga);
}